/* jshint esversion: 6 */
import * as _ from 'underscore';

export default function SortModule(list, key, direction, groupFxns) {
	let search = (item) => {
    		let path = key.split("."),
    			target = item,
    			i = 0;

    		for (i = 0; i < path.length; ++i) {
    			if (target[path[i]]) {
    				target = target[path[i]];
    			} else {
    				return 0;
    			}
    		}

			if (_.isString(target)) {
				if (target.match(/[\d]+-[\d]+-[\d]+/)) {
	    			return new Date(target).getTime();
	    		} else {
					return target.toLowerCase();
				}
			}

    		return target;

    	},
        sortedList = list;

	/*
	 * `groupFxns` sorts within bands rather than across the whole list: each
	 * predicate claims its members, and the bands keep the order they were given
	 * in. Callers use it to sink a band without hiding it — socials needing a
	 * reconnect sort last instead of being filtered out of the store.
	 *
	 * Anything no predicate claims is appended rather than dropped, so a caller
	 * whose predicates don't cover the list loses the grouping, not the rows.
	 */
	if (groupFxns) {
		let sortedGroups = [],
			claimed = [],
			/*
			 * `direction` orders within a band, never across them: the bands are
			 * the caller's priority, so reversing the flattened list would lift
			 * the sunk band back to the top.
			 */
			sortGroup = (group) => {
				let sorted = _.sortBy(group, search);

				return (direction === 'DESC') ? sorted.reverse() : sorted;
			};

		groupFxns.map((groupFxn) => {
			let group = list.filter(groupFxn);

			claimed = claimed.concat(group);
			sortedGroups.push(sortGroup(group));
		});

		sortedGroups.push(sortGroup(_.difference(list, claimed)));

		sortedList = _.flatten(sortedGroups, true);
	} else {
		// for last post or active: first sort by id so we have a kind of stable sort
		if (key.match('lastPost') || key.match('active')) {
			sortedList = _.sortBy(sortedList, 'id');
		}
		if (!key.match('psID')) {
			sortedList = _.sortBy(sortedList, search);
		} else {
			sortedList = [];
			let groupList = _.groupBy(list, (item) => {
					return item.psID;
				}),
				/*
				 * Every posting service has to appear here: the loop below builds
				 * the result from this order alone, so a service left out drops its
				 * accounts from the list entirely rather than merely sorting them
				 * last.
				 */
				groupSort = [
					2, // POST_SVC_FACEBOOK
					1, // POST_SVC_TWITTER
					8, // POST_SVC_INSTAGRAM_BUSINESS
					38, // POST_SVC_TIKTOK
					41, // POST_SVC_YOUTUBE
					42, // POST_SVC_THREADS
					20, // POST_SVC_GMYBUSINESS
					4, // POST_SVC_LINKEDIN
					5, // POST_SVC_PINTEREST
					43, // POST_SVC_SNAPCHAT
					30, // POST_SVC_BLOGGER
					24, // POST_SVC_DISCORD
					39, // POST_SVC_BLUESKY
					37, // POST_SVC_MASTODON
					36, // POST_SVC_REDDIT
					7, // POST_SVC_FEED
					23, // POST_SVC_SLACK
					22, // POST_SVC_STOCKTWITS
					3, // POST_SVC_TUMBLR
					35, // POST_SVC_WORDPRESS
					40, // POST_SVC_NEXTDOOR
				];

			for (let index in groupSort) {
				let svcKey = groupSort[index];
				if (groupList[svcKey] !== undefined) {
					for (let i = 0; i < groupList[svcKey].length; ++i) {
						sortedList.push(groupList[svcKey][i]);
					}
				}
			}
		}

		if (direction === 'DESC') {
			sortedList.reverse();
		}
	}

    return sortedList;

}
